import script from "./UserIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./UserIndex.vue?vue&type=script&setup=true&lang=js"

import "./UserIndex.vue?vue&type=style&index=0&id=ccead86e&lang=css"

const __exports__ = script;

export default __exports__